/** Signaling WebSocket URL. Override with VITE_SIGNALING_URL at build time. */
export const SIGNALING_URL =
  import.meta.env.VITE_SIGNALING_URL ??
  (import.meta.env.DEV
    ? `${location.protocol === "https:" ? "wss" : "ws"}://${location.host}/ws`
    : `${location.protocol === "https:" ? "wss" : "ws"}://${location.hostname}:8787`);

export const ICE_SERVERS: RTCIceServer[] = [
  { urls: "stun:stun.l.google.com:19302" },
  { urls: "stun:stun1.l.google.com:19302" },
];

export const PLAYER_NAME = "Gunslinger";
